<template>
	<div v-if="imiGoShippingMethods.length > 0">
		<div v-if="numberOfProductsSentFromStore > 0 && canShipNow && firstShippingMethod && ! isDownload">
			<div  v-for="(shippingMethodItem, index) in shipFromStoreNowMethods" :key="shippingMethodItem.id">
				<shippingMethodItem
					@click.native="selectShippingMethod(shippingMethodItem, false, true)"
					v-if="splittableMethodIds.includes(shippingMethodItem.id)"
					:shippingMethod="shippingMethodItem"
					:selectedMethodId="selectedMethodId"
					:selectedZipCode="selectedZipCode"
					:stockAvailability="stockAvailability"
					:isLastRow="index === (imiGoShippingMethods.length - 1)"
					:selectedShippingOption="selectedShippingOption"
					@update:selectedShippingMethodId="v => $emit('update:selectedShippingMethodId', v)"
					@update:selectedShippingOption="v => $emit('update:selectedShippingOption', v)"
					:cart="cart"
					:isActive="isActive"
					:numberOfProductsSentFromStore="numberOfProductsSentFromStore"
					:isAllProductsSentFromStore="isAllProductsSentFromStore"
					:firstShippingMethod="firstShippingMethod"
					:involvesShipFromStore="involvesShipFromStore"
				/>
				<div v-if="isActive" class="col-xs-12 divider" :class="{'border-bottom': index != shipFromStoreNowMethods.length - 1}" />
			</div>
		</div>

		<div v-else-if="numberOfProductsSentFromStore > 0 && ! firstShippingMethod && canShipNow && ! isDownload">
			<div v-for="(shippingMethodItem, index) in shipFromStoreLaterMethods" :key="shippingMethodItem.id">
				<shippingMethodItem
					v-if="!splittableShippingOptions.includes(shippingMethodItem.id)"
					@click.native="selectShippingMethod(shippingMethodItem, false, true)"
					:shippingMethod="shippingMethodItem"
					:selectedMethodId="selectedMethodId"
					:selectedZipCode="selectedZipCode"
					:stockAvailability="stockAvailability"
					:isLastRow="index === (imiGoShippingMethods.length - 1)"
					:selectedShippingOption="selectedShippingOption"
					@update:selectedShippingMethodId="v => $emit('update:selectedShippingMethodId', v)"
					@update:selectedShippingOption="v => $emit('update:selectedShippingOption', v)"
					:cart="cart"
					:isActive="isActive"
					:numberOfProductsSentFromStore="numberOfProductsSentFromStore"
					:isAllProductsSentFromStore="isAllProductsSentFromStore"
					:firstShippingMethod="firstShippingMethod"
					:involvesShipFromStore="involvesShipFromStore"
				/>
				<div v-if="isActive" class="col-xs-12 divider" :class="{'border-bottom': index != shipFromStoreLaterMethods.length - 1}" />
			</div>
		</div>

		<div v-else >
			<div v-for="(shippingMethodItem, index) in imiGoShippingMethods" :key="shippingMethodItem.id">
				<shippingMethodItem
					@click.native="selectShippingMethod(shippingMethodItem, false, true)"
					:shippingMethod="shippingMethodItem"
					:selectedMethodId="selectedMethodId"
					:selectedZipCode="selectedZipCode"
					:stockAvailability="stockAvailability"
					:isLastRow="index === (imiGoShippingMethods.length - 1)"
					:selectedShippingOption="selectedShippingOption"
					@update:selectedShippingMethodId="v => $emit('update:selectedShippingMethodId', v)"
					@update:selectedShippingOption="v => $emit('update:selectedShippingOption', v)"
					:numberOfProductsSentFromStore="numberOfProductsSentFromStore"
					:cart="cart"
					:isActive="isActive"
					:canShipNow="canShipNow"
					:isDownload="isDownload"
					:involvesShipFromStore="involvesShipFromStore"
				/>
				<div v-if="isActive" class="col-xs-12 divider" :class="{'border-bottom': ! (selectedShippingMethodId === shippingMethodItem.id || index === (imiGoShippingMethods.length - 1))}" />
			</div>
		</div>
		<div v-if="displayMoreBtn" class="list-group-item col-xs-12" @click="showMore = true">
			<span class="glyphicon glyphicon-chevron-down" />
			<a class="pl-5">Visa fler</a>
		</div>
	</div>
	<loading-spinner v-else />
</template>

<script>
import alert from 'alert';
import bus from 'eventbus';
import mediaQuery from 'mediaQuery';
import localSessionStorage from 'localSessionStorage';
import shippingMethodItem from './shipping-method-item';
import { mapGetters, mapState } from 'vuex';
import { selectCheckoutOption } from 'gtm';
import { debounce, isEqual } from 'lodash';

export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		cart: {
			type: Object,
			required: true,
		},
		shippingPriceMap: {
			type: Object,
			required: true,
		},
		testConstraint: {
			type: Function,
		},
		selectedZipCode: {
			type: Number,
		},
		stockAvailability: {
			type: Object,
			required: true,
		},
		isActive: {
			type: Boolean,
		},
		activeStep: {
			type: Number,
		},
		selectedShippingOption: {},
		selectedShippingMethodId: {},
		isCorporateCustomer: {
			type: Boolean,
			required: true,
		},
		numberOfProductsSentFromStore: {
			type: Number,
		},
		firstShippingMethod: {
			type: Boolean,
		},
		isAllProductsSentFromStore: {
			type: Boolean
		},
		canShipNow: {
			type: Boolean
		},
		isDownload: {
			type: Boolean,
			default: false,
		},
		mostExpensiveProductInCart: {},
		imiGoShippingMethods: {},
		involvesShipFromStore: {
			type: Boolean
		},
	},
	components: {
		shippingMethodItem,
	},
	data() {
		return {
			mediaQuery,
			selectedMethodId: null,
			shippingMethods: [],
			showMore: false,
			errorAlertSent: false,
			excludedShippingMethods: {},
			shippingPrice: 0,
			noBorderBottomNotLoggedIn: [1, 4, 5],
			noBorderBottomLoggedIn: [2, 4, 5, 6],
			shipFromStoreNowMethods: [],
			shipFromStoreLaterMethods: []
		};
	},
	created () {
		this.debouncer = debounce(this.debouncer, 500);
	},
	mounted () {
		let checkoutData = localSessionStorage.get('checkoutData');
		if (checkoutData) {
			checkoutData = JSON.parse(checkoutData);

			if (checkoutData?.returningFromBriqpay && ! checkoutData.isStoreReservation) {
				const methodItem = this.imiGoShippingMethods.find((method) => method.id === checkoutData.selectedShippingMethodId);
				this.selectShippingMethod(methodItem, true);
				bus.$emit('shipping-updated', this.shippingPrice);
			}
		}

		this.$emit('update:highestPackageSizeId', this.highestPackageSizeId);
	},
	methods: {
		debouncer: function () {
			this.handleShippingPriceChange();
		},
		handleShippingPriceChange () {
			const updatedPrice = this.shippingPriceMap[this.selectedMethodId];
			/* Checks if price shippingPriceMap differs from current shippingPrice */
			if (updatedPrice !== this.shippingPrice) {
				this.shippingPrice = updatedPrice;
			}
		},
		selectShippingMethod (item, shippingMethodsUpdated = false, isClick = false) {
			if (! item) {
				if (this.activeStep === 1) {
					this.selectedMethodId = null;
					this.shippingPrice = 0;
				}
				return;
			}
			// if (! item) {
			// 	this.selectedMethodId = null;
			// 	this.$emit('update:selectedShippingMethodId', null);
			// 	this.shippingPrice = 0;
			// } else
			if (! this.isActive && ! shippingMethodsUpdated) {
				bus.$emit('stepUpdated', 2, null);
			} else if (this.activeStep === 1) {
				this.shippingPrice = 0;
			} else if ((item.id !== this.selectedMethodId) || (this.isActive && this.selectedShippingMethodId === null)) {
				if (isClick) {
					selectCheckoutOption(2, item.name);
				}

				this.selectedMethodId = item.id;
				// this.selectedMethodId = this.isVisible ? this.selectedMethodId : null;
				const shippingPrice = this.selectedMethodId ? item.price : 0;
				localSessionStorage.set('checkout:selectedShippingMethodId', this.selectedMethodId);
				localSessionStorage.set('checkout:selectedShippingServiceCode', item.deliveryCode);
				this.$emit('update:selectedShippingMethodId', this.selectedMethodId);
				this.shippingPrice = shippingPrice;
			}
		},
		defaultShippingMethod () {
			if (this.shippingMethods.length) {
				let savedMethodId = localSessionStorage.get('checkout:selectedShippingMethodId');

				if ((this.selectedShippingMethodId === null && ! savedMethodId) || this.numberOfProductsSentFromStore > 0) {
					// Vi vill inte autovälja något för "nya" besökare
					return;
				}
				if (this.isStoreReservation && this.testConstraint('shippingMethod', 4)) {
					this.$emit('update:selectedShippingMethodId', 4);
					return;
				}
				let value = null;
				if (savedMethodId) {
					savedMethodId = parseInt(savedMethodId);
				}
				let savedMethod = null;
				for (const method of this.shippingMethods) {
					if (method.disabled) {
						continue;
					}
					if (method.value === savedMethodId) {
						savedMethod = method;
					}
					if (value === null || value === 20 /* Fri frakt ska ej prioriteras */) {
						value = method;
					}
					if (method.value === this.selectedShippingMethodId) {
						value = method;
					}
				}

				this.selectShippingMethod(savedMethod ? savedMethod : value, true);
			}
		},
	},
	computed: {
		availableShippingMethods() {
			return this.showMore ? this.imiGoShippingMethods : this.imiGoShippingMethods.slice(0, 7);
		},
		highestPackageSizeId () {
			let highestPackageSizeId = -1;
			for (const row of this.cart.rows) {
				const pid = row.product.packageSizeId | 0;
				if (pid > highestPackageSizeId) {
					highestPackageSizeId = pid;
				}
			}
			return highestPackageSizeId;
		},
		isVisible () {
			return this.imiGoShippingMethods.some(method => method.id === this.selectedMethodId);
		},
		displayMoreBtn () {
			if (this.showMore || ! this.isActive) {
				return false;
			}

			if (this.imiGoShippingMethods.length > 7) {
				return true;
			}
			return false;
		},
		orderVolume () {
			let volume = 0;
			for (const row of this.cart.rows) {
				volume += Math.ceil(row.product.packageVolume / 1000000);
			}
			return volume;
		},
		orderWeight () {
			let weight = 0;
			for (const row of this.cart.rows) {
				weight += row.product.packageWeight;
			}
			return weight;
		},
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
			cartSum: 'cart/sum',
		}),
		...mapState({
			splittableShippingOptions: state => state.shippingMethodRelatedInfo.splittableShippingOptions,
			fromStoreShipmentOptions: state => state.shippingMethodRelatedInfo.fromStoreShipmentOptions,
		}),
	},
	watch: {
		cartSum () {
			// this.getShippingMethods();
		},
		shippingMethods () {
			this.defaultShippingMethod();
		},
		isCorporateCustomer () {
			// this.getShippingMethods();
		},
		selectedZipCode (to) {
			// this.getShippingMethods();
		},
		imiGoShippingMethods () {
			if (this.numberOfProductsSentFromStore > 0) {
				this.shipFromStoreNowMethods = this.imiGoShippingMethods.filter(method => (this.fromStoreShipmentOptions.includes(method.id)));
				this.shipFromStoreLaterMethods = this.imiGoShippingMethods.filter(method => (!this.fromStoreShipmentOptions.includes(method.id)));
			}
		},
		isActive (to) {
			if (to) {
				let methodId = 0;
				if (! this.selectedShippingMethodId) {
					this.selectShippingMethod(this.imiGoShippingMethods[0], true);
					if (this.isAllProductsSentFromStore) {
						methodId = null;
					}
					this.selectShippingMethod(this.imiGoShippingMethods[methodId], true);
				}
				const method = Object.assign({}, this.shippingMethods.find(m => m.id == this.selectedMethodId));
				const price = this.shippingPriceMap[method.value + ''];

				if (price) {
					bus.$emit('shipping-updated', price);
					this.shippingPrice = price;
				}
			}
		},
		selectedMethodId (to, frm) {
			const method = Object.assign({}, this.imiGoShippingMethods.find(m => m.id == to));
			const price = this.shippingPriceMap[method.id + ''];
			this.$emit('update:stepSelection', method.name);
			this.shippingPrice = price;
		},
		shippingPrice (to, frm) {
			if (to !== frm) {
				bus.$emit('shipping-updated', to);
			}
		},
		activeStep (to) {
			if (to === 1) {
				this.selectShippingMethod(null, false);
			}
		},
		shippingPriceMap (to, frm) {
			if (to !== frm && this.selectedMethodId) {
				this.debouncer.call();
			}
		},
		highestPackageSizeId (to) {
			this.$emit('update:highestPackageSizeId', to);
		},
	},
};
</script>

